import { Modal } from 'react-daisyui';
import { FileText, X } from 'lucide-react';

const DocumentModal = ({ label, title, onClose, footer, children }) => (
  <Modal
    open
    style={{ margin: 0, backgroundColor: 'rgba(15, 23, 42, 0.45)' }}
    className="flex max-h-[calc(100dvh-1.5rem)] w-[92%] max-w-2xl flex-col overflow-hidden rounded-2xl p-0 shadow-2xl sm:max-h-[calc(100vh-4rem)]"
  >
    <div className="flex shrink-0 items-center gap-3 bg-secondary-900 px-4 py-3.5 sm:gap-4 sm:px-5 sm:py-4">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white sm:h-11 sm:w-11">
        <FileText size={20} strokeWidth={2} />
      </span>

      <div className="min-w-0 flex-1">
        <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-white/50 sm:text-[11px]">{label}</p>
        <h3 className="truncate text-base font-bold text-white sm:text-lg">{title}</h3>
      </div>

      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white/10 text-white transition-colors hover:bg-white/20"
      >
        <X size={18} strokeWidth={2.5} />
      </button>
    </div>

    {children}

    <div className="flex shrink-0 items-center justify-between gap-3 border-t border-gray-100 px-4 py-3.5 sm:px-6 sm:py-4">
      {footer}
    </div>
  </Modal>
);

export default DocumentModal;
